// extracted by mini-css-extract-plugin
export var list = "switcher-module--list--22FdP";
export var listActiveItem = "switcher-module--list-active-item--GBm1d";
export var listItem = "switcher-module--list-item--y-Z6m";
export var lowerHolder = "switcher-module--lower-holder--w9jYK";
export var topWrapper = "switcher-module--top-wrapper--XBZSe";
export var trainingTypeItem = "switcher-module--training-type-item--Zk9Jq";
export var underLine = "switcher-module--under-line--9uZIi";